import CATEGORY_ID_TO_STRING from "@/misc/productCategory";

export default function (value) {
  if (!value) {
    return "-";
  }

  return CATEGORY_ID_TO_STRING[value];
}
